module.exports = __webpack_public_path__ + "media/images/countrysquared/cx-107911cdb8e83f267893bcb9da0d9389.svg";